import { render } from "./Room.vue?vue&type=template&id=b79112e4"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
script.render = render

export default script